import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Transport } from '../../../shared/api/model/transport';
import { AgentService } from '../../../shared/api/resources/agent/agent.service';
import { Route } from '../../../shared/api/model/route';
import { TransportIteraction } from '../../../shared/api/model/transport-iteraction';
import { RouteSchedule } from '../../../shared/api/model/route-schedule';
import { RouteItinerary } from '../../../shared/api/model/route-itinerary';
import { AgentReservationService } from '../../../shared/api/resources/agent-reservation/agent-reservation.service';
import * as moment from 'moment';
import { Location } from '../../../shared/api/model/location';
import { StaticUtils } from '../../../shared/utils/static-utils';
import { EventComponent } from '../../../shared/api/model/event-component';
import { GenderPrice } from '../../../shared/api/model/gender-price';
import { ToastsManager } from 'ng2-toastr';

@Component({
  selector: 'app-book-transport',
  templateUrl: './book-transport.component.html',
  styleUrls: ['./book-transport.component.scss']
})

export class BookTransportComponent implements OnInit {
  @Input('transport') transport = new Transport();
  @Input('routes') routes = [];
  @Input('supplierId') supplierId: number | string;
  @Input('hasAccess') hasAccess: boolean;
  @Input('hasTransportSelected') hasTransportSelected: boolean = false;
  @Input('hasTransport') hasTransport: boolean = false;
  @Input('hasAvailableTransport') hasAvailableTransport: boolean = false;
  @Output() onChange = new EventEmitter<Transport>();
  @Output() onChangeExtraTransports = new EventEmitter<EventComponent[]>();
  @Input('extrasFromEventComponents') extrasFromEventComponents = [];
  @Input('genderPrices') genderPrices: GenderPrice[] = [];
  @Input('components') components: EventComponent[];
  @Input('event') event = [];

  private _onChangeTimeout = setTimeout(() => { }, 0);

  private _oneWay = false;
  private _roundTrip = false;
  private _noTransportation = true;

  private _selectedPickupRoute: Route;
  private _selectedDropoffRoute: Route;

  private _selectedPickupItenerary: RouteItinerary;
  private _selectedDropoffItenerary: RouteItinerary;

  private _selectedPickupSchedule: RouteSchedule;
  private _selectedPickupScheduleDate = StaticUtils.formatDateForBackend(moment());
  private _selectedDropoffSchedule: RouteSchedule;
  private _selectedDropoffScheduleDate = StaticUtils.formatDateForBackend(moment());

  private _pickup = false;
  private _dropoff = false;

  private _customPickup = false;
  private _customPickupFrom = '';
  private _customPickupTo = '';
  private _customPickupDate = StaticUtils.formatDateForBackend(moment());
  private _customPickupTime = '12:00';

  private _customDropoff = false;
  private _customDropoffFrom = '';
  private _customDropoffTo = '';
  private _customDropoffDate = StaticUtils.formatDateForBackend(moment());
  private _customDropoffTime ='12:00';

  private _customDisablePickUp = false;
  private _customDisableDropOff = false;

  utils = StaticUtils;
  moment = moment;

  pickupIteraction = new TransportIteraction();
  dropoffIteraction = new TransportIteraction();

  dropoffList: {label: string; value: object}[] = [];
  pickupList: {label: string; value: object}[] = [];

  pickupItenerariesList: {label: string; value: object}[] = [];
  dropoffItenerariesList: {label: string; value: object}[] = [];

  pickupSchedulesList: {label: string; value: object}[] = [];
  dropoffSchedulesList: {label: string; value: object}[] = [];

  constructor(private _agentService: AgentService, private _agentReservationService: AgentReservationService, private _toastr: ToastsManager) {}

  ngOnInit() {
    this.initEventDates();
    this.initExtraTransportsComp();
    this.hasAvailableTransports();
    this.validateTransports();
    this.initCustomBtn();

    if (this.hasAccess) {
      if (this.supplierId) {
        this.initPickupAndDropoffLists();
      }
      
      if (this.transport.transfers) {
        if (this.transport.transfers.length === 0) {
          this.hasTransportSelected = false;
          this.oneWay = false;
          this.roundTrip = false;
          this.noTransportation = true;
        } else if (this.transport.transfers.length === 1) {
          this.hasTransportSelected = true;
          this.oneWay = true;
          this.roundTrip = false;
          this.noTransportation = false;
        } else if (this.transport.transfers.length === 2) {
          this.hasTransportSelected = true;
          this.oneWay = false;
          this.roundTrip = true;
          this.noTransportation = false;
        }

        for (const transfer of this.transport.transfers) {
          if (transfer.transportDirection === 1) {
            this.pickupIteraction = transfer;
            if (!this.pickupIteraction.isCustom) {
              if (this.pickupIteraction.route) {
                this._selectedPickupRoute = this.pickupIteraction.route;
                const selectedRoute: any = this.pickupList.find((list: any) => list.value.id === this.pickupIteraction.route.id);
                this.selectedPickupRoute = selectedRoute.value;
              }
              if (this.pickupIteraction.stop) {
                this._selectedPickupItenerary = new RouteItinerary();
                this._selectedPickupItenerary.stop = this.pickupIteraction.stop;
                this._selectedPickupItenerary.stop.note = this.pickupIteraction.stop.note;
              }
              if (this.pickupIteraction.schedule) {
                this._selectedPickupSchedule = this.pickupIteraction.schedule;
                this._selectedPickupScheduleDate = this.pickupIteraction.schedule.date;
              }
            } else {
              this._customPickup = transfer.isCustom;
              if (this.pickupIteraction.stop) {
                this._customPickupFrom = this.pickupIteraction.stop.name;
              }
              if (this.pickupIteraction.exitStop) {
                this._customPickupTo = this.pickupIteraction.exitStop.name;
              }
              if (this.pickupIteraction.schedule) {
                this._customPickupDate = this.pickupIteraction.schedule.date;
                this._customPickupTime = this.pickupIteraction.schedule.time;
              }
            }
          }
          if (transfer.transportDirection === 2) {
            this.dropoffIteraction = transfer;
            if (!this.dropoffIteraction.isCustom) {
              this.dropoffIteraction = transfer;
              if (this.dropoffIteraction.route) {
                this._selectedDropoffRoute = this.dropoffIteraction.route;
              }
              if (this.dropoffIteraction.stop) {
                this._selectedDropoffItenerary = new RouteItinerary();
                this._selectedDropoffItenerary.stop = this.dropoffIteraction.stop;
              }
              if (this.dropoffIteraction.schedule) {
                this._selectedDropoffSchedule = this.dropoffIteraction.schedule;
                this._selectedDropoffScheduleDate = this.dropoffIteraction.date;
              } 
            } else {
              this._customDropoff = transfer.isCustom;
              if (this.dropoffIteraction.stop) {
                this._customDropoffFrom = this.dropoffIteraction.stop.name;
              }
              if (this.dropoffIteraction.exitStop) {
                this._customDropoffTo = this.dropoffIteraction.exitStop.name;
              }
              if (this.dropoffIteraction.schedule) {
                this._customDropoffDate = this.dropoffIteraction.schedule.date;
                this._customDropoffTime = this.dropoffIteraction.schedule.time;
              }
            }
          }
        }
      } else {
        this.transport.transfers = [];
      }
    }
  }

  initCustomBtn() {
    const routesPickup = this.routes.some((route) => {
      return route['type'] === 1;
    })

    const routesDropoff = this.routes.some((route) => {
      return route['type'] === 2;
    })

    this._customDisablePickUp = routesPickup ? false : true;
    this._customDisableDropOff = routesDropoff ? false : true;
    this._customPickup = routesPickup ? false : true;
    this._customDropoff = routesDropoff ? false : true;
  }

  toogleButtons(compId: number, compPrice: number, btnValue: boolean) {
    if (this.totalPax > 0) {
      this.updateComponentQuantity(compId, compPrice, btnValue);
    } else {
      this.showError('Please add pax at the reservation first!');
    }
  }

  updateComponentQuantity(componentId: number, priceId: number, isToAddTransport: boolean) {
    for (const component of this.components) {
      if (component.component.componentType === 1) {
        if (component.component.id === componentId && component.componentPrice.id === priceId) {
          if (isToAddTransport) {
            component.quantity = this.totalPax;
            this.hasTransportSelected = true;
            if (!this.roundTrip) {
              this.oneWay = true;
            } else {
              this.roundTrip = true;
            }
          } else {
            component.quantity = 0;
            this.hasTransportSelected = false;
            this.noTransportation = true; 
          }
        } else {
          component.quantity = 0;
        }
      }
    }

    this.onChangeExtraTransports.emit(this.components);
  }

  initExtraTransportsComp() {
    if (this.components === undefined) {
      this.components = this.extrasFromEventComponents;
      this.components.map( (component) => {
        if (component.component.componentType === 1 && component.originalQuantity === undefined) {
          component.originalQuantity = component.quantity;
        }
        component.quantity = 0;
      })
    }
  }

  hasAvailableTransports() {
    let totalSeats: number = 0;
    let isUnlimited: boolean = false;
    
    for(const component of this.components) {
      if (component.component.componentType === 1 && component.quantityAvailable > 0 && (component.quantityAvailable >= this.totalPax 
        || component.quantityAvailable <= 0) && (component.originalQuantity !== component.quantityBooked || component.originalQuantity === 0)) {
        totalSeats += component.quantityAvailable;
      } else {
        if (component.component.componentType === 1 && component.quantityAvailable <= 0 && (component.originalQuantity !== component.quantityBooked 
          || component.originalQuantity === 0)) {
          isUnlimited = true;
        }
      }
    }

    if (totalSeats > 0 || isUnlimited) {
      this.hasAvailableTransport = true;
    } else {
      this.hasAvailableTransport = false;
    }
  }

  validateTransports() {
    for(const component of this.components) {
      if (component.component.componentType === 1) {
        this.hasTransport = true;
        break;
      }
    }
  }

  showError(msg: string) {
    this._toastr.warning(msg, 'Warning!');
  }

  initEventDates() {
    this.selectedPickupScheduleDate = StaticUtils.formatDateForBackend(moment(this.event['start'].split(' ')[0]));
    this.selectedDropoffScheduleDate = StaticUtils.formatDateForBackend(moment(this.event['start'].split(' ')[0]));
    this.customPickupDate = StaticUtils.formatDateForBackend(moment(this.event['start'].split(' ')[0]));
    this.customDropoffDate = StaticUtils.formatDateForBackend(moment(this.event['start'].split(' ')[0]));
  }

  initPickupAndDropoffLists() {
    for (const route of this.routes) {
      if (route['type'] === 1) {
        this.pickupList.push({label: route['name'], value: route});
      } else if (route['type'] === 2) {
        this.dropoffList.push({label: route['name'], value: route});
      }
    }
  }

  onModelChange() {
    clearTimeout(this._onChangeTimeout);
    this._onChangeTimeout = setTimeout(() => {
      this.pickupIteraction.isCustom = this.customPickup;
      if (!this.pickupIteraction.isCustom) {
        if (
          this._selectedPickupRoute &&
          this._selectedPickupItenerary &&
          this._selectedPickupItenerary.stop &&
          this._selectedPickupSchedule
        ) {
          this.pickupIteraction.route = this._selectedPickupRoute;
          this.pickupIteraction.stop = this._selectedPickupItenerary.stop;
          this.pickupIteraction.exitStop = this._selectedPickupRoute.routeDestination;
          this.pickupIteraction.schedule = this._selectedPickupSchedule ? this._selectedPickupSchedule : new RouteSchedule();
          this.pickupIteraction.schedule.date = this._selectedPickupScheduleDate;
        }
      } else {
        this.pickupIteraction.order = 0;
        this.pickupIteraction.stop = new Location();
        this.pickupIteraction.stop.name = this._customPickupFrom;
        this.pickupIteraction.exitStop = new Location();
        this.pickupIteraction.exitStop.name = this._customPickupTo;
        this.pickupIteraction.schedule = new RouteSchedule();
        this.pickupIteraction.schedule.date = this._customPickupDate;
        this.pickupIteraction.schedule.time = this._customPickupTime;
      }

      this.dropoffIteraction.isCustom = this.customDropoff;
      if (!this.dropoffIteraction.isCustom) {
        if (
          this._selectedDropoffRoute &&
          this._selectedDropoffItenerary &&
          this._selectedDropoffItenerary.stop &&
          this._selectedDropoffItenerary
        ) {
          this.dropoffIteraction.route = this._selectedDropoffRoute;
          this.dropoffIteraction.stop = this._selectedDropoffItenerary.stop;
          this.dropoffIteraction.exitStop = this._selectedDropoffRoute.routeDestination;
          this.dropoffIteraction.schedule = this._selectedDropoffSchedule ? this._selectedDropoffSchedule : new RouteSchedule();
          this.dropoffIteraction.schedule.date = this._selectedDropoffScheduleDate;
        }
      } else {
        this.dropoffIteraction.order = 0;
        this.dropoffIteraction.stop = new Location();
        this.dropoffIteraction.stop.name = this._customDropoffFrom;
        this.dropoffIteraction.exitStop = new Location();
        this.dropoffIteraction.exitStop.name = this._customDropoffTo;
        this.dropoffIteraction.schedule = new RouteSchedule();
        this.dropoffIteraction.schedule.date = this._customDropoffDate;
        this.dropoffIteraction.schedule.time = this._customDropoffTime;
      }

      this.transport.transfers = [];
      if (this._oneWay) {
        this.pickupIteraction.transportDirection = 1;
        this.transport.transfers.push(this.pickupIteraction);
      }
      if (this._roundTrip) {
        this.pickupIteraction.transportDirection = 1;
        this.transport.transfers.push(this.pickupIteraction);
        this.dropoffIteraction.transportDirection = 2;
        this.transport.transfers.push(this.dropoffIteraction);
      }
      this.onChange.emit(this.transport);
    }, 200);
  }

  get selectedDropoffRoute(): Route {
    return this._selectedDropoffRoute;
  }

  set selectedDropoffRoute(value: Route) {
    this._selectedDropoffRoute = value;
    this.dropoffIteraction.route = this._selectedDropoffRoute;
    this.onModelChange();

    this.dropoffItenerariesList = [];
    this.dropoffSchedulesList = [];
    if (this.dropoffIteraction.route.iteneraries) {
      for (const itenerary of this.dropoffIteraction.route.iteneraries) {
        this.dropoffItenerariesList.push({label: itenerary.stop.name, value: itenerary});
      }
      if (this.dropoffItenerariesList.length > 0) {
        this.dropoffItenerariesList.splice(this.dropoffItenerariesList.length - 1, 1);
      }
    }
  }

  get pickup(): boolean {
    return this._pickup;
  }

  set pickup(value: boolean) {
    this._pickup = value;
    this.onModelChange();
  }

  get dropoff(): boolean {
    return this._dropoff;
  }

  set dropoff(value: boolean) {
    this._dropoff = value;
    this.onModelChange();
  }

  get oneWay(): boolean {
    return this._oneWay;
  }

  set oneWay(value: boolean) {
    if (this._oneWay !== value) {
      this._oneWay = value;
      if (this._oneWay) {
        this._roundTrip = false;
        this._noTransportation = false;
      }
      this.onModelChange();
    }
  }

  get roundTrip(): boolean {
    return this._roundTrip;
  }

  set roundTrip(value: boolean) {
    if (this._roundTrip !== value) {
      this._roundTrip = value;
      if (this._roundTrip) {
        this._oneWay = false;
        this._noTransportation = false;
      }
      this.onModelChange();
    }
  }

  get noTransportation(): boolean {
    return this._noTransportation;
  }

  set noTransportation(value: boolean) {
    if (this._noTransportation !== value) {
      this._noTransportation = value;
      if (this._noTransportation) {
        this._oneWay = false;
        this._roundTrip = false;
      }
      this.onModelChange();
    }
  }

  get selectedPickupRoute(): Route {
    return this._selectedPickupRoute;
  }

  set selectedPickupRoute(value: Route) {
    this._selectedPickupRoute = JSON.parse(JSON.stringify(value));
    this.pickupIteraction.route = this._selectedPickupRoute;
    this.onModelChange();

    this.pickupItenerariesList = [];
    this.pickupSchedulesList = [];
    if (this.pickupIteraction.route.iteneraries) {
      for (const itenerary of this.pickupIteraction.route.iteneraries) {
        this.pickupItenerariesList.push({label: itenerary.stop.name, value: itenerary});
      }
      if (this.pickupItenerariesList.length > 0) {
        this.pickupItenerariesList.splice(this.pickupItenerariesList.length - 1, 1);
      }
    }
  }

  get selectedDropoffItenerary(): RouteItinerary {
    return this._selectedDropoffItenerary;
  }

  set selectedDropoffItenerary(value: RouteItinerary) {
    this._selectedDropoffItenerary = value;
    this.dropoffIteraction.route.iteneraries = [this._selectedDropoffItenerary];
    this.onModelChange();

    this.dropoffSchedulesList = [];
    if (this._selectedDropoffItenerary && this._selectedDropoffItenerary.schedules) {
      for (const schedule of this._selectedDropoffItenerary.schedules) {
        this.dropoffSchedulesList.push({label: schedule.timeShort , value: schedule});
      }
    }
  }

  get selectedPickupItenerary(): RouteItinerary {
    return this._selectedPickupItenerary;
  }

  set selectedPickupItenerary(value: RouteItinerary) {
    this._selectedPickupItenerary = value;
    this._selectedPickupItenerary.stop.note = value.note;
    this.pickupIteraction.route.iteneraries = [this._selectedPickupItenerary];
    this.onModelChange();

    this.pickupSchedulesList = [];
    if (this._selectedPickupItenerary && this._selectedPickupItenerary.schedules) {
      for (const schedule of this._selectedPickupItenerary.schedules) {
        this.pickupSchedulesList.push({label: schedule.timeShort , value: schedule});
      }
    }
  }

  get selectedDropoffSchedule(): RouteSchedule {
    return this._selectedDropoffSchedule;
  }

  set selectedDropoffSchedule(value: RouteSchedule) {
    this._selectedDropoffSchedule = value;
    this.onModelChange();
  }

  get selectedPickupSchedule(): RouteSchedule {
    return this._selectedPickupSchedule;
  }

  set selectedPickupSchedule(value: RouteSchedule) {
    this._selectedPickupSchedule = value;
    this.onModelChange();
  }

  get selectedDropoffScheduleDate(): string {
    return this._selectedDropoffScheduleDate;
  }

  set selectedDropoffScheduleDate(value: string) {
    this._selectedDropoffScheduleDate = value;
    this.onModelChange();
  }

  get selectedPickupScheduleDate(): string {
    return this._selectedPickupScheduleDate;
  }

  set selectedPickupScheduleDate(value: string) {
    this._selectedPickupScheduleDate = value;
    this.onModelChange();
  }

  get customDropoff(): boolean {
    return this._customDropoff;
  }

  set customDropoff(value: boolean) {
    this._customDropoff = value;
    this.onModelChange();
  }

  get customPickup(): boolean {
    return this._customPickup;
  }

  set customPickup(value: boolean) {
    this._customPickup = value;
    this.onModelChange();
  }

  get customDisablePickUp(): boolean {
    return this._customDisablePickUp;
  }

  set customDisablePickUp(value: boolean) {
    this._customDisablePickUp = value;
    this.onModelChange();
  }

  get customDisableDropOff(): boolean {
    return this._customDisableDropOff;
  }

  set customDisableDropOff(value: boolean) {
    this._customDisableDropOff = value;
    this.onModelChange();
  }
  
  get customPickupFrom(): string {
    return this._customPickupFrom;
  }

  set customPickupFrom(value: string) {
    this._customPickupFrom = value;
    this.onModelChange();
  }

  get customPickupTo(): string {
    return this._customPickupTo;
  }

  set customPickupTo(value: string) {
    this._customPickupTo = value;
    this.onModelChange();
  }

  get customPickupDate(): string {
    return this._customPickupDate;
  }

  set customPickupDate(value: string) {
    this._customPickupDate = value;
    this.onModelChange();
  }

  get customPickupTime(): string {
    return this._customPickupTime;
  }

  set customPickupTime(value: string) {
    this._customPickupTime = value;
    this.onModelChange();
  }

  get customDropoffFrom(): string {
    return this._customDropoffFrom;
  }

  set customDropoffFrom(value: string) {
    this._customDropoffFrom = value;
    this.onModelChange();
  }

  get customDropoffTo(): string {
    return this._customDropoffTo;
  }

  set customDropoffTo(value: string) {
    this._customDropoffTo = value;
    this.onModelChange();
  }

  get customDropoffDate(): string {
    return this._customDropoffDate;
  }

  set customDropoffDate(value: string) {
    this._customDropoffDate = value;
    this.onModelChange();
  }

  get customDropoffTime(): string {
    return this._customDropoffTime;
  }

  set customDropoffTime(value: string) {
    this._customDropoffTime = value;
    this.onModelChange();
  }

  get totalPax(): number {
    let result = 0;

    for (const comp of this.genderPrices) {
      if (comp.quantityToBook > 0) {
        result += comp.quantityToBook;
      }
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/experiences/booking/book-transport/book-transport.component.ts